import React from 'react';
import { withRouter } from 'react-router-dom';

import axios from 'axios';
import { Form, Upload, Modal, Button, Icon, Checkbox, Select, Alert, notification } from 'antd';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import apiPath from 'apiPath';
import './layout.css';

function getBase64(img, callback) {
	const reader = new FileReader();
	reader.addEventListener('load', () => callback(reader.result));
	reader.readAsDataURL(img);
}

const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 6 },
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 14 },
	},
	marginBottom: '8pt'
};

const buttonStyle = {
	textAlign: 'right'
};


class EditProgram extends React.Component {

	state = {
		mainImageLoading: false,
		carouselImage1Loading: false,
		carouselImage2Loading: false,
		carouselImage3Loading: false,

		selectedMainImage: null,
		selectedCarouselImage1: null,
		selectedCarouselImage2: null,
		selectedCarouselImage3: null,
		showSaveSuccessful: false,

		fileList: [],
		previewVisible: false,
		previewImage: '',
		componentMounted: false
	}

	handleSubmit = (event) => {
		event.preventDefault();

		this.props.form.validateFields((err, values) => {
			if (!err) {
				values.ExcursionId = this.props.location.selectedFieldProgram.ExcursionId;
				values.MainImage = this.state.selectedMainImage != null ? this.state.selectedMainImage.response :
					this.props.location.selectedFieldProgram.MainImage != null ? this.props.location.selectedFieldProgram.MainImage : null;

				const files = this.state.fileList;
				values.CarouselImages = [
					{ "CarouselImage1": files[0] ? files[0].existingFile ? files[0].url : files[0].response : null },
					{ "CarouselImage2": files[1] ? files[1].existingFile ? files[1].url : files[1].response : null },
					{ "CarouselImage3": files[2] ? files[2].existingFile ? files[2].url : files[2].response : null }
				];

				//console.log('Received values of form: ', values);
				axios.put(apiPath + '/fieldAdmin/updateFieldProgram', {
					withCredentials: true,
					form: values
				}).then(response => {
					//console.log(response);
					//don't navigate off
					notification.success({
						message: 'Save Successful.',
						description: 'Your changes have been saved.',
						duration: 4.5
					});

					/*
					this.props.history.push({
						pathname:"/portal/fieldadmin/View Programs",
						data: {successfullySaved: true, searchCriteria: { Id: this.props.location.selectedFieldProgram.CruiseId, Value:this.props.location.selectedFieldProgram.CruiseNumber }}
					});
					*/
				}).catch(error => {
					console.error(error);
					notification.error({
						message: 'Error Saving',
						description: 'There was an issue trying to save your changes.  Please try again.',
						duration: 4.5
					});
				});
			}
		});
	}
	handleFormCancel = (event) => {
		event.preventDefault();

		this.props.history.push({
			pathname: "/portal/fieldadmin/View Programs",
			data: { searchCriteria: { Id: this.props.location.selectedFieldProgram.CruiseId, Value: this.props.location.selectedFieldProgram.CruiseNumber } }
		});
	}
	handleUpload(info) {
		console.log("files: " + JSON.stringify(info));
		this.setState({ 'selectedFiles': info.fileList });
		console.log("files: " + JSON.stringify(info.fileList));
	}
	onChangeMain = info => {
		const nextState = {};
		info.fileList = [];

		switch (info.file.status) {
			case "uploading":
				nextState.selectedMainImage = info.file;
				this.setState({ mainImageLoading: true });
				break;
			case "done":
				nextState.selectedMainImage = info.file;
				getBase64(info.file.originFileObj, MainImage => this.setState({ MainImage, mainImageLoading: false }));
				break;

			default:
				// error or removed
				nextState.selectedMainImage = null;
		}
		this.setState(() => nextState);
	};
	handlePreview = (file) => {
		this.setState({
			previewImage: file.url || file.thumbUrl,
			previewVisible: true,
		});
	}
	handleChange = ({ fileList }) => this.setState({ fileList })
	handleCancel = () => this.setState({ previewVisible: false })
	handleRemove = (file) => {
		let filename = file.name;

		if (!file.existingFile)
			filename = file.response.substring(file.response.lastIndexOf("/") + 1, file.response.lastIndexOf("."));

		console.log(filename);

		// axios.delete(apiPath + '/fieldAdmin/removeImage', {
		// 	withCredentials: true,
		// 	data: { "directoryName": this.props.location.selectedFieldProgram.CruiseNumber, "filename": filename }
		// }).then(response => {
		// 	console.log(response);
		// }).catch(console.error);
	}
	updateFileListState(files) {
		this.setState({ fileList: files })
	}
	redirect() {
		//window.location.href="/View Programs";//if you do this it requires sign in everytime, you have to use some other method
		this.props.history.push({
			pathname: "/portal/fieldadmin/View Programs",
		});
	}
	componentDidMount() {
		this.setState({ componentMounted: true });
		//console.log(this.props.location.selectedFieldProgram);
	}
	componentWillUnmount() {

		if (this.props.history.action === "POP") {
			//back button was used
			this.props.history.replace({
				pathname: "/portal/fieldadmin/View Programs",
				data: { searchCriteria: { Id: this.props.location.selectedFieldProgram.CruiseId, Value: this.props.location.selectedFieldProgram.CruiseNumber } }
			});
		}
	}

	render() {
		if (!this.props.location.selectedFieldProgram) {
			this.redirect();//if this fails for any reason we display message.
			return <h3 style={{ marginLeft: '15px' }}>Direct navigation to this page, and page refreshes are not supported, please select a program to edit from View Programs link on the left.</h3>
		}
		const { previewVisible, previewImage, fileList, componentMounted } = this.state;
		const { getFieldDecorator } = this.props.form;
		const REACT_VERSION = React.version;
		const {
			CruiseNumber, Code, Title, Summary, Description, Itinerary, Inclusions, Notes,
			IsFastPaced, IsLeanIn, IsStrenuous, MainImage, CarouselImages, physical_activity_level
		} = this.props.location.selectedFieldProgram;


		//spread not working? 		const { CarouselImage1, CarouselImage2, CarouselImage3 } = CarouselImages;
		const CarouselImageLength = CarouselImages.length;
		let CarouselImage1 = null;
		let CarouselImage2 = null;
		let CarouselImage3 = null;

		if (CarouselImageLength > 0) {
			CarouselImage1 = CarouselImages[0];
		}
		if (CarouselImageLength > 1) {
			CarouselImage2 = CarouselImages[1];
		}
		if (CarouselImageLength > 2) {
			CarouselImage3 = CarouselImages[2];
		}

		const mainImg = this.state.MainImage == null ? MainImage : this.state.MainImage;
		const carouselImg1 = this.state.CarouselImage1 == null ? CarouselImage1 : this.state.CarouselImage1;
		const carouselImg2 = this.state.CarouselImage2 == null ? CarouselImage2 : this.state.CarouselImage2;
		const carouselImg3 = this.state.CarouselImage3 == null ? CarouselImage3 : this.state.CarouselImage3;

		const imgRoot = apiPath.replace('/api', '');

		if (!componentMounted) {
			if (carouselImg1 != null) {
				const carouselImg1URL = carouselImg1.indexOf('?') > 0 ? carouselImg1.split('?')[0] : carouselImg1;
				fileList.push({
					uid: -1,
					name: Code + '_1',
					status: 'done',
					url: carouselImg1URL + "?" + new Date().getTime(),
					existingFile: true
				});
			}
			if (carouselImg2 != null) {
				const carouselImg2URL = carouselImg2.indexOf('?') > 0 ? carouselImg2.split('?')[0] : carouselImg2;
				fileList.push({
					uid: -2,
					name: Code + '_2',
					status: 'done',
					url: carouselImg2URL + "?" + new Date().getTime(),
					existingFile: true
				});
			}
			if (carouselImg3 != null) {
				const carouselImg3URL = carouselImg3.indexOf('?') > 0 ? carouselImg3.split('?')[0] : carouselImg3;
				fileList.push({
					uid: -3,
					name: Code + '_3',
					status: 'done',
					url: carouselImg3URL + "?" + new Date().getTime(),
					existingFile: true
				});
			}
		}
		const uploadButton = (
			<div>
				<Icon type="plus" />
				<div className="ant-upload-text">Upload</div>
			</div>
		);

		return (
			<Form onSubmit={this.handleSubmit}>
				<legend style={{ marginLeft: '15px' }}>Edit Field Program<span style={{ float: 'right', marginRight: '30px' }}>React version: {REACT_VERSION}</span></legend>
				<h1 style={{ textAlign: 'center', paddingBottom: '25px' }}>{Title} ({Code})</h1>
				<Form.Item label="Summary" {...formItemLayout}>
					{getFieldDecorator('Summary', {
						initialValue: Summary,
						//rules: [{ required: true, message: 'Summary is required' }]
					})(
						//<Input />
						<ReactQuill theme="snow"
							onChange={() => this.handleSummaryChange}
							modules={EditProgram.modules}
							formats={EditProgram.formats}
						/>
					)}
				</Form.Item>
				<Form.Item label="Description" {...formItemLayout}>
					{getFieldDecorator('Description', {
						initialValue: Description,
						//rules: [{ required: true, message: 'Description is required' }]
					})(
						<ReactQuill theme="snow"
							onChange={() => this.handleDescriptionChange}
							modules={EditProgram.modules}
							formats={EditProgram.formats}
						/>
					)}
				</Form.Item>
				<Form.Item label="Itinerary" {...formItemLayout}>
					{getFieldDecorator('Itinerary', {
						initialValue: Itinerary,
						//rules: [{ required: true, message: 'Itinerary is required' }]
					})(
						//<Input />
						<ReactQuill theme="snow"
							onChange={() => this.handleItineraryChange}
							modules={EditProgram.modules}
							formats={EditProgram.formats}
						/>
					)}
				</Form.Item>
				<Form.Item label="Inclusions" {...formItemLayout}>
					{getFieldDecorator('Inclusions', {
						initialValue: Inclusions,
						//rules: [{ required: true, message: 'Inclusions is required' }]
					})(
						//<Input />
						<ReactQuill theme="snow"
							onChange={() => this.handleInclusionsChange}
							modules={EditProgram.modules}
							formats={EditProgram.formats}
						/>
					)}
				</Form.Item>
				<Form.Item label="Notes" {...formItemLayout}>
					{getFieldDecorator('Notes', {
						initialValue: Notes,
						//rules: [{ required: true, message: 'Notes is required' }]
					})(
						//<Input />
						<ReactQuill theme="snow"
							onChange={() => this.handleNotesChange}
							modules={EditProgram.modules}
							formats={EditProgram.formats}
						/>
					)}
				</Form.Item>
				<Form.Item label="Is Fast Paced?"  {...formItemLayout}>
					{getFieldDecorator('IsFastPaced', {
						initialValue: IsFastPaced,
						valuePropName: 'checked'
					})(
						<Checkbox />
					)}
				</Form.Item>
				<Form.Item label="Is Lean In?" {...formItemLayout}>
					{getFieldDecorator('IsLeanIn', {
						initialValue: IsLeanIn,
						valuePropName: 'checked'
					})(
						<Checkbox />
					)}
				</Form.Item>
				<Form.Item label="Is Strenuous?" {...formItemLayout}>
					{getFieldDecorator('IsStrenuous', {
						initialValue: IsStrenuous,
						valuePropName: 'checked'
					})(
						<Checkbox />
					)}
				</Form.Item>
				<Form.Item label="Mobility Level" {...formItemLayout}>
					{getFieldDecorator('physical_activity_level', {
						initialValue: physical_activity_level,
						valuePropName: 'defaultValue'
					})(
						<Select defaultValue={physical_activity_level}>
							<Option key="0" value='0'>None</Option>
							<Option key="1" value='1'>1</Option>
							<Option key="2" value='2'>2</Option>
							<Option key="3" value='3'>3</Option>
							<Option key="4" value='4'>4</Option>
						</Select>
					)}
				</Form.Item>
				<Form.Item label="Image" {...formItemLayout}
					extra="Click image to change program image">
					{getFieldDecorator('MainImage', {
						//rules: [{ required: true, message: 'Main image is required' }]
						/*
						rules: [
								{
									validator(rule, value, callback){
										if(!value){
											if(!mainImg){
												callback("Main image is required");
											}
										}
										callback();
									}
								}
							]
						*/
					})(
						<Upload
							className="avatar-uploader"
							name={Code}
							accept=".jpg"
							multiple={false}
							showUploadList={false}
							file={this.state.selectedMainImage}
							data={{ "directoryName": CruiseNumber, "fileName": Code }}
							action={apiPath + '/fieldAdmin/saveImage'}
							onChange={this.onChangeMain}
						>
							{
								mainImg && !this.state.mainImageLoading
									? <img src={`${imgRoot}${mainImg}${mainImg.includes('base64') ? "" : `?${new Date().getTime()}`}`} alt="Main Image" className='avatar-scaled' />
									: this.state.mainImageLoading ? <Icon type="loading" className="avatar-uploader-trigger" /> : <Icon type="plus" className="avatar-uploader-trigger" />
							}
						</Upload>
					)}
				</Form.Item>
				<Form.Item label="Carousel Image(s)" {...formItemLayout}>
					{getFieldDecorator('CarouselImages', {
						//rules: [{ required: true, message: 'At least one carousel image is required' }]
						// rules: [
						// 	{
						// 		validator(rule, value, callback){
						// 			if(!value){
						// 				if(!carouselImg1 && !carouselImg2 && !carouselImg3){
						// 					callback("At least one carousel image is required");
						// 				}
						// 			}
						// 			callback();
						// 		}
						// 	}
						// ] //carousel image are not required.
					})(
						<div className="clearfix">
							<Upload
								data={{ "directoryName": CruiseNumber, "fileName": Code + "_" + (fileList.length + 1) }}
								action={apiPath + '/fieldAdmin/saveImage'}
								listType="picture-card"
								fileList={fileList}
								onPreview={this.handlePreview}
								onChange={this.handleChange}
								onRemove={this.handleRemove}
								defaultFileList={fileList}
							>
								{fileList.length >= 3 ? null : uploadButton}
							</Upload>

							<Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
								<img alt="carousel image" className='avatar-scaled' src={previewImage.indexOf("base64") !== -1 ? previewImage : imgRoot + previewImage} />
							</Modal>
						</div>
					)}
				</Form.Item>
				<Form.Item {...formItemLayout} style={buttonStyle}>
					<Button
						type="primary"
						htmlType="submit"
						icon="save"
					>
						{this.props.buttonText || 'Save'}
					</Button> &nbsp;
					<Button
						type="default"
						htmlType="button"
						onClick={this.handleFormCancel}
					>
						Close
					</Button>
				</Form.Item>
			</Form>
		);
	}
}

EditProgram.modules = {
	toolbar: {
		container: [
			[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
			[{ 'align': [] }],
			['bold', 'italic', 'underline'],
			[{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'color': ['#000000', '#e60000', '#ff9900', '#ffff00', '#008a00', '#0066cc', '#9933ff', '#ffffff', '#facccc', '#ffebcc', '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff', '#bbbbbb', '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0', '#c285ff', '#888888', '#a10000', '#b26b00', '#b2b200', '#006100', '#0047b2', '#6b24b2', '#444444', '#5c0000', '#663d00', '#666600', '#003700', '#002966', '#3d1466', 'custom-color'] }, { 'background': [] }, 'link'],
		],
		handlers: {
			'color': function (value) {
				if (value == 'custom-color') value = window.prompt('Enter Hex Color Code');
				this.quill.format('color', value);
			}
		}
	},
	clipboard: {
		// toggle to add extra line breaks when pasting HTML:
		matchVisual: false,
	}
}

EditProgram.formats = [
	'header', 'font', 'size',
	'bold', 'italic', 'underline', 'strike', 'blockquote',
	'list', 'bullet', 'indent', 'align',
	'link', 'image', 'background', 'color',
]

export default withRouter(Form.create()(EditProgram));



// WEBPACK FOOTER //
// ./portal-components/Portal/FieldAdmin/EditProgram/index.jsx